import React from "react";

const cars = [

    {
    title: "Maruti Swift Dzire",
    brand: "Maruti",
    location: "City Center",
    price: 70,
    reviews: 130,
    transmission: "Manual",
    mileage: "17 KM/L",
    fuel: "Petrol",
    year: 2020,
    img: "/images/fleet/Maruti-swift-Dzire.jpg",
  },
  {
    title: "Toyota Etios",
    brand: "Toyota",
    location: "City Center",
    price: 85,
    reviews: 110,
    transmission: "Manual",
    mileage: "14 KM/L",
    fuel: "Petrol",
    year: 2019,
    img: "/images/fleet/Toyota-Etios.jpg",
  },

  {
    title: "Honda Amaze",
    brand: "Honda",
    location: "City Center",
    price: 75,
    reviews: 100,
    transmission: "Manual",
    mileage: "16 KM/L",
    fuel: "Petrol",
    year: 2020,
    img: "/images/fleet/Honda-Amaze.jpg",
  },
  {
    title: "Innova Crysta",
    brand: "Toyota",
    location: "Airport",
    price: 150,
    reviews: 180,
    transmission: "Manual",
    mileage: "12 KM/L",
    fuel: "Diesel",
    year: 2022,
    img: "/images/fleet/Innova-Crysta.jpg",
  },
  {
    title: "Maruti Ertiga",
    brand: "Maruti",
    location: "City Center",
    price: 80,
    reviews: 140,
    transmission: "Manual",
    mileage: "15 KM/L",
    fuel: "Petrol",
    year: 2020,
    img: "/images/fleet/Maruti-Ertiga.jpg",
  },


  {
    title: "Mini Bus",
    brand: "Unknown",
    location: "City Center",
    price: 200,
    reviews: 50,
    transmission: "Manual",
    mileage: "8 KM/L",
    fuel: "Diesel",
    year: 2019,
    img: "/images/fleet/mini-bus.jpg",
  },
];

const PopularCars = () => {
  return (
    <section className="car-section">
      <div className="container">
        <div className="section-heading heading-four" data-aos="fade-down">
          <h2>Explore Our Fleet</h2>
          <p>Choose from our range of popular cab service vehicles</p>
        </div>

        <div className="row">
          {cars.map((car, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <div className="listing-item listing-item-two">
                <div className="listing-img">
                  <a href="#">
                    <img src={car.img} className="img-fluid" alt={car.title} />
                  </a>

                  <div className="fav-item">
                    <div className="d-flex align-items-center gap-2">
                      <span className="featured-text">{car.brand}</span>
                      <span className="availability">Available</span>
                    </div>

                    <a href="#" className="fav-icon">
                      <i className="feather-heart"></i>
                    </a>
                  </div>

                  <span className="location">
                    <i className="bx bx-map me-1"></i>
                    {car.location}
                  </span>
                </div>

                <div className="listing-content">
                  <div className="listing-features d-flex align-items-center justify-content-between">
                    <div className="list-rating">
                      <h3 className="listing-title">
                        <a href="#">{car.title}</a>
                      </h3>

                      <div className="list-rating">
                        <i className="fas fa-star filled"></i>
                        <i className="fas fa-star filled"></i>
                        <i className="fas fa-star filled"></i>
                        <i className="fas fa-star filled"></i>
                        <i className="fas fa-star"></i>
                        <span>(5.0) {car.reviews} Reviews</span>
                      </div>
                    </div>

             
                  </div>

                  <div className="listing-details-group">
                    <ul>
                      <li>
                        <img src="/img/icons/car-parts-01.svg" alt="" />
                        <p>{car.transmission}</p>
                      </li>

                      <li>
                        <img src="/img/icons/car-parts-02.svg" alt="" />
                        <p>{car.mileage}</p>
                      </li>

                      <li>
                        <img src="/img/icons/car-parts-03.svg" alt="" />
                        <p>{car.fuel}</p>
                      </li>

              
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularCars;